export default __webpack_public_path__ + "static/media/close_new.0e0433cd.svg";